



















import {Vue,Component, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import Toolbar from '@/components/beta/Toolbar.vue';
import FullDialog from '@/components/UI/FullDialog.vue';
import FullPlan from "@/components/UI/FullPlan.vue";
import SidebarFull from '@/components/common/widget/SidebarFull.vue';
import ModalError from '@/components/UI/ModalError.vue';
import TopAlert from '@/components/UI/TopAlert.vue';
import ModalSupport from "@/components/UI/ModalSupport.vue";

const appStore = namespace('app')
const dialog = namespace('dialog')
const workspace = namespace('workspace')
const profile = namespace('profile')

@Component({
  components: {
    Toolbar,
    FullDialog,
    SidebarFull,
    ModalError,
    FullPlan,
    TopAlert,
    ModalSupport,
  }
})
export default class LayoutFull  extends Vue {

  @appStore.Mutation('setScrollHeight') protected setScrollHeight: any
  @appStore.Getter('GetScrollHeight') protected GetScrollHeight:any
  @workspace.Getter('getPlan') protected getPlan: any
  @workspace.Getter('getPlanStatus') protected getPlanStatus: any
  @workspace.Getter('getCurrentExhibition') protected getCurrentExhibition: any
  @workspace.Mutation('setCurrentExhibition') protected setCurrentExhibition: any
  @dialog.Getter('topAlertShow') protected topAlertShow: any
  @dialog.Mutation('SetTopAlert') protected SetTopAlert: any
  @profile.Getter('getCurrentCompany') protected getCurrentCompany:any

  @Ref('box') readonly box!:HTMLElement

  onScroll () {
  }

  async mounted() {
    await this.setCurrentExhibition(this.$route.params.showCode)
    this.SetTopAlert(false)
    if(this.getCurrentCompany && (this.getCurrentCompany.role == 'owner' || this.getCurrentCompany.role == 'marketer' || this.getCurrentCompany.role =='support') && (this.getPlan == 'free' || this.getPlanStatus == 'waiting_payment') && (+new Date() / 1000).toFixed() < this.getCurrentExhibition.end) {
      this.SetTopAlert(true)
    }
  }
}

